import * as React from "react";
import env from "../../../utils/env";
import ps_logo from "../../../../public/pracitioner_app-icon.png";
import tm_logo from "../../../../public/collaboration_app-icon.png";

interface OwnProps {
  errorMessage: string | null;
  signin: (username: string, password: string) => void;
}

interface OwnState {
  username: string;
  password: string;
  canSignin: boolean;
  showTmLogin: boolean;
}

type Props = OwnProps;

class Signin extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      canSignin: false,
      showTmLogin: false
    };

    this.usernameChanged = this.usernameChanged.bind(this);
    this.passwordChanged = this.passwordChanged.bind(this);
    this.signin = this.signin.bind(this);
  }

  private usernameChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState(
      {
        username: e.target.value
      },
      () => this.validate()
    );
  };

  private passwordChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState(
      {
        password: e.target.value
      },
      () => this.validate()
    );
  };

  private validate = () => {
    this.setState({
      canSignin: !!(this.state.username && this.state.password)
    });
  };

  public signin = () => {
    this.props.signin(this.state.username, this.state.password);
  };

  private toggleTmLogin = () => {
    this.setState({
      showTmLogin: !this.state.showTmLogin
    });
  };

  private getPsSigninUrl = (): string => {
    return env.PROJECT19_API_ROOT + "oauth2/init/perfectserve/";
  };

  public render() {
    const { username, password, canSignin, showTmLogin } = this.state;
    return (
      <div className="signinContainer">
        <div className="mt-50 pl-15 pr-15 center">
          Please select the type of account that you have to sign in.
        </div>
        <div className="mt-50">
          <a href={this.getPsSigninUrl()}>
            <img alt="PerfectServe" src={ps_logo} height={150} />
          </a>
        </div>

        <div className="mt-25">
          <div className="pointer" role="button" tabIndex={0} onClick={this.toggleTmLogin}>
            <img alt="Telmediq" src={tm_logo} height={150} />
          </div>
        </div>

        {showTmLogin && (
          <div className="fadeIn">
            <div className="input mt-50">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                className="form-control"
                value={username}
                onChange={this.usernameChanged}
              />

              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                className="form-control"
                value={password}
                onChange={this.passwordChanged}
              />
              {this.props.errorMessage ? (
                <div className="input-error">{this.props.errorMessage}</div>
              ) : null}
              <button className="signin-btn" onClick={this.signin} disabled={!canSignin}>
                Sign In
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Signin;
